import { motion } from 'framer-motion';
import { FiCheckCircle } from 'react-icons/fi';

const points = [
  {
    title: 'Outcome-led delivery',
    body: 'We tie milestones to business metrics—so technology investments are justified in plain language.',
  },
  {
    title: 'Security embedded early',
    body: 'Threat modeling and least-privilege patterns are part of design—not an afterthought before go-live.',
  },
  {
    title: 'Operational honesty',
    body: 'Clear runbooks, ownership, and escalation paths—your team always knows what “good” looks like.',
  },
];

const WhyUs = () => {
  return (
    <section id="why-us" className="py-20 md:py-28 border-y border-slate-200 bg-surface-elevated scroll-mt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Why teams choose <span className="text-gradient-warm">us</span>
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed">
              We are not another generic vendor deck. We work as an extension of your leadership—with
              pragmatic roadmaps, transparent trade-offs, and engineering discipline you can audit.
            </p>
          </motion.div>

          <ul className="space-y-6">
            {points.map((p, i) => (
              <motion.li
                key={p.title}
                initial={{ opacity: 0, x: 16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.45 }}
                className="flex gap-4"
              >
                <FiCheckCircle className="h-6 w-6 shrink-0 text-brand-amber mt-0.5" />
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">{p.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{p.body}</p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
